module.exports = __webpack_public_path__ + "static/media/400059_01.5f3636a8.png";